import {MouseEventHandler} from 'react';
import {ReactNode} from 'react';

import cn from 'classnames';

import {ButtonLinkMods, ButtonLinkSize} from './ButtonLink';

import s from './ButtonLink.module.css';

export interface ButtonProps {
  id?: string;
  onClick: MouseEventHandler<HTMLButtonElement>;
  onMouseEnter?: MouseEventHandler<HTMLButtonElement>;
  onMouseLeave?: MouseEventHandler<HTMLButtonElement>;
  mod?: ButtonLinkMods;
  href?: string;
  title?: string;
  dataQa?: string;
  className?: string;
  classNameContentContainer?: string;
  children?: ReactNode;
  isDisabled?: boolean;
  size?: ButtonLinkSize;
  type?: 'button' | 'submit';
}

export function Button({
  id,
  mod = ButtonLinkMods.ButtonYellow,
  title,
  className,
  classNameContentContainer,
  children,
  isDisabled,
  dataQa,
  size,
  type = 'button',
  onClick,
  onMouseEnter,
  onMouseLeave,
}: ButtonProps): JSX.Element {
  const isEnableContentContainer =
    mod === ButtonLinkMods.ButtonPrimary ||
    mod === ButtonLinkMods.ButtonSecondary ||
    mod === ButtonLinkMods.ButtonHexadecimal;

  return (
    <button
      id={id}
      className={cn(s[`${mod}`], className, {
        [s.sizeXS]: size === ButtonLinkSize.XS,
        [s.sizeS]: size === ButtonLinkSize.S,
        [s.sizeM]: size === ButtonLinkSize.M,
        [s.sizeL]: size === ButtonLinkSize.L,
      })}
      onClick={onClick}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      onTouchStart={() => {}}
      type={type}
      disabled={isDisabled}
      title={title}
      aria-label={title}
      data-qa={dataQa}
    >
      {isEnableContentContainer ? <span className={cn(s.text, classNameContentContainer)}>{children}</span> : children}
    </button>
  );
}
